import { selectors } from "@redux/index";
import { useTypedSelector } from "@redux/store";
import { shallowEqual } from "react-redux";

const DataLayerExternalKeys = () => {
    const { loggedInDetails } = useTypedSelector((state) => ({
        loggedInDetails: selectors.loggedInDetails(state),
    }), shallowEqual);

    const dataLayerExternalKeys = {
        page_category: "post-login",
        country: "taiwan",
        language: "chinese",
        channel: "loyalty",
        campaign_id: "8601",
        campaign_name: "tw_bec_receipt_2026mar",
        campaign_type: "loyalty",
        external_id: loggedInDetails?.lineId || "",
        external_type: "line",
        user_segment: "",
        user_status: "logged in",
        user_journey_status: "",
        flow_type: ""
    };

    return dataLayerExternalKeys;
};

const DataLayerPoints = () => {
    const { loggedInDetails } = useTypedSelector((state) => ({
        loggedInDetails: selectors.loggedInDetails(state),
    }), shallowEqual);

    const dataLayerPoints = {
        'brands_point_acquired': loggedInDetails?.acquiredBrandsPoints || 0,
        'line_points_acquired': loggedInDetails?.acquiredLinePoints || 0,
        'scan_day_num': '',
        'scan_day': '',
        'energy_level': loggedInDetails?.chickenEnergyPercent || 0,
        'chicken_state': loggedInDetails?.chickenLevelName?.toLowerCase() || ''
    }

    return dataLayerPoints;
}

const DataLayerProducts = () => {
    const { datalayers } = useTypedSelector((state) => ({
        loggedInDetails: selectors.loggedInDetails(state),
        datalayers: selectors.datalayers(state),
    }), shallowEqual);

    const datalayerProduct = {
        ...datalayers
    }
    delete datalayerProduct?.location

    return datalayerProduct;
};

const DataLayerIPLocation = () => {
    const { datalayers } = useTypedSelector((state) => ({
        datalayers: selectors.datalayers(state),
    }), shallowEqual);

    const datalayerIPLocation = {
        'continent_name': datalayers?.location?.continentName || '',
        'country_code': datalayers?.location?.countryCode || '',
        'country_name': datalayers?.location?.countryName || '',
        'region_code': datalayers?.location?.regionCode || '',
        'region_name': datalayers?.location?.regionName || '',
        'city': datalayers?.location?.city || '',
        'zip_code': datalayers?.location?.zipCode || '',
        'latitude': datalayers?.location?.latitude || 0,
        'longitude': datalayers?.location?.longitude || 0,
        'native_language': datalayers?.location?.nativeLanguage || ''
    }

    return datalayerIPLocation;
};

export { DataLayerExternalKeys, DataLayerProducts, DataLayerIPLocation, DataLayerPoints };
